import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';
import { BUSINESS_TOOL_MODE } from 'constants/businessTool';

import { IBusinessPlanType } from 'interfaces/businessPlan';
import { IBusinessToolModes } from 'interfaces/businessTool';

export const checkIsPreviewMode = (mode: IBusinessToolModes) => {
  return mode === BUSINESS_TOOL_MODE.PREVIEW;
};

export const checkIsOnePageBP = (type: IBusinessPlanType) => {
  return type === BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT || type === BUSINESS_PLAN_TYPES.ONE_PAGE;
};

export const checkIsOnePagePreviewMode = (mode: IBusinessToolModes, type: IBusinessPlanType) => {
  const isPreview = checkIsPreviewMode(mode);
  const isOnePage = checkIsOnePageBP(type);

  return isPreview && isOnePage;
};
